module.exports = __webpack_public_path__ + "img/icon-sound-on.2ecf2ad4.svg";